<!--
입금확인요청 수정
------------------------------------
-->
<template>
    <!-- 폼 화면 -->

    <div class="confirm-overlay" ref="confirm-overlay" v-show="display">
        <div class="confirm-dialog p-1rem">


            <div class="mt-1rem uk-flex uk-flex-between uk-flex-bottom">
                <div class="font-bold text-black">
                    입금확인 요청 - 수정하기
                </div>


                <button
                    type="button"
                    class="uk-button uk-button-small uk-button-danger"

                    @click="cancel"
                >
                    <i class="material-icons">cancel</i>
                    요청취소
                </button>

            </div>

            <table class="info-table small uk-width-1-1 border-highlight mt-1rem">
                <colgroup>
                    <col style="width: 9rem">
                    <col>
                </colgroup>

                <tr>
                    <th class="uk-text-right">
                        입금일
                    </th>
                    <td>
                        <app-input-text
                            placeholder="예) 2024-01-31"

                            v-model.trim="inputs.deposit_at"
                        ></app-input-text>
                    </td>

                </tr>

                <tr>
                    <th class="uk-text-right">
                        입금자명
                    </th>
                    <td>
                        <app-input-text
                            placeholder="실제 입금자명을 정확하게 적어주세요"

                            v-model.trim="inputs.deposit_name"
                        ></app-input-text>
                    </td>

                </tr>

                <tr>
                    <th class="uk-text-right">
                        입금액
                    </th>
                    <td>
                        <app-input-text
                            placeholder=""

                            v-model.trim="inputs.amount"
                        ></app-input-text>

                        <!-- TASK-117: 입금액 실시간 콤마 표시 (표시 전용 — input 값 비변경) -->
                        <div class="mt-0d25rem" v-show="amountParsed !== null">
                            <template v-if="amountValid">
                                <span>입력 금액 :</span>
                                <strong class="uk-text-primary" style="font-size:1.25rem">{{ amountDisplay }}</strong> 원
                            </template>
                            <span v-else class="uk-text-danger font-bold">{{ amountErrorMessage }}</span>
                        </div>
                    </td>

                </tr>


            </table>

            <div class="uk-text-right mt-1rem">

                <!--- 버튼 -->
                <button
                    type="button"
                    class="uk-button uk-button-default"

                    @click="hideForm"
                >
                    <span uk-icon="icon: close"></span> 취소
                </button>


                <button
                    type="button"
                    class="uk-button uk-button-primary"

                    @click="submit"
                >
                    <span uk-icon="icon: check"></span>
                    저장
                </button>
            </div>

        </div>
    </div>

</template>

<script>

export default {
    mixins: [
    ],
    props: {
        // csrf-token
        csrfToken: String,
    },
    data: function () {
        return {
            // (bool) 폼 display 여부
            display: false,

            // (object) 요청정보
            req: {},

            /**
             * 입력값
             */
            inputs: {
                deposit_at: null,
                deposit_name: null,
                amount: null,
            },
        };
    },
    mounted: function () {
        //console.log('mounted in component');
    },
    computed: {
        /**
         * 입금액 파싱값 (TASK-117)
         * 서버 check_price_string() (app/helpers.php) 파싱 규칙 미러링 — 콤마·통화기호 제거 후 numeric 판정
         * @return {?number} null: 빈값 / NaN: 비숫자 / number: 유효값
         */
        amountParsed() {
            let raw = this.inputs.amount;

            if (raw === null || raw === undefined || raw === '') {
                return null;
            }

            // 컴마,통화단위제거 (check_price_string 미러)
            let cleaned = String(raw).replace(/[,$₩¥€]/gi, '');

            if (cleaned === '' || isNaN(Number(cleaned))) {
                return NaN;
            }

            return Number(cleaned);
        },

        /**
         * 입금액 형식 유효 여부 (숫자로 파싱 가능한지 — 부호/크기는 무관) (TASK-117)
         * @return {boolean}
         */
        amountFormatValid() {
            return this.amountParsed !== null && ! isNaN(this.amountParsed);
        },

        /**
         * 입금액 유효 여부 (형식 유효 + 0 초과) (TASK-117 3-B F-4 — 음수·0 은 danger 강등)
         * @return {boolean}
         */
        amountValid() {
            return this.amountFormatValid && this.amountParsed > 0;
        },

        /**
         * 입금액 무효 안내 문구 (TASK-117 3-B F-4 — 서버 예외 메시지와 톤 일치)
         * @return {string}
         */
        amountErrorMessage() {
            if (! this.amountFormatValid) {
                return '숫자만 입력해 주세요.';
            }

            return '입금액이 올바르지 않습니다.(0원 이하 불가)';
        },

        /**
         * 입금액 표시용 콤마 포맷 문자열 (TASK-117 — 소수 최대 2자리, DB float(12,2) 정합)
         * @return {string}
         */
        amountDisplay() {
            if (! this.amountValid) {
                return '';
            }

            return this.amountParsed.toLocaleString('ko-KR', {maximumFractionDigits: 2});
        },
    },
    methods: {
        /**
         * 입력폼 display
         */
        displayForm() {
            // 컨펌 엘리먼트 body 밑으로 이동
            document.body.appendChild(this.$refs['confirm-overlay']);
            this.display = true;
        },

        /**
         * 입력폼 hide
         */
        hideForm() {
            // 컨펌 엘리먼트 body 밑으로 이동
            this.display = false;
        },

        /**
         * 폼 띄우기
         */
        form(req_id) {
            // 초기화
            this.inputs = {
                deposit_at: null,
                deposit_name: null,
                amount: null,
            };

            // promise 생성
            let load = new Promise((resolve, reject) => {
                //reject('failed !');

                // ajax 옵션
                let opts = {
                    type: 'get',
                    url: '/bank-deposit-requests/' + req_id,
                    contentType: 'application/json',
                    data: {},
                    success: (response, textStatus, jqXHR) => {
                        // promise 성공
                        resolve(response);
                    },
                };

                // ajax 실행
                $.app.ajax.module.background(opts);
            });


            // promise 처리
            load.then((response) => {
                this.req = response.req;

                // 입력값 설정
                if (this.req.deposit_at) {
                    this.inputs.deposit_at = moment(this.req.deposit_at).format('YYYY-MM-DD');
                }
                this.inputs.deposit_name = this.req.deposit_name;
                this.inputs.amount = this.req.amount;

                //console.log(response);
                // 폼띄우기
                this.displayForm();
            });
        },

        /**
         * 서브밋 전 검증
         * @return Promise
         */
        submitValidation() {
            return new Promise((resolve, reject) => {
                // 입력값 검증
                if (! this.inputs.deposit_at) {
                    reject('입금일은 필수입니다.');
                    return;
                }
                if (! this.inputs.deposit_name) {
                    reject('입금자명은 필수입니다.');
                    return;
                }
                if (! this.inputs.amount) {
                    reject('입금액은 필수입니다.');
                    return;
                }

                resolve();
            });


        },

        /**
         * submit
         */
        submit() {
            // 입력값 검증처리
            this.submitValidation().then(() => {
                return new Promise((resolve, reject) => {

                    // ajax 옵션
                    let opts = {
                        type: 'patch',
                        url: '/bank-deposit-requests/' + this.req.id,
                        data: _.merge({
                            '_token': this.csrfToken,
                        }, this.inputs),
                        success: (response, textStatus, jqXHR) => {
                            // promise 성공
                            resolve(response);
                        },
                    };

                    // ajax 실행
                    $.app.ajax.module.default(opts);
                });
            }).then((response) => {
                this.display = false;
                UIkit.modal.alert(response.msg).then(() => {
                    // 완료이벤트
                    this.$emit('done');

                });
            }).catch((msg) => {
                alert(msg);
            });



        },

        /**
         * 요청취소
         */
        cancel() {
            // 컨펌
            if (! confirm('입금확인 요청을 취소하시겠습니까?')) {
                return;
            }

            // 입력값 검증처리
            this.submitValidation().then(() => {
                return new Promise((resolve, reject) => {

                    // ajax 옵션
                    let opts = {
                        type: 'patch',
                        url: '/bank-deposit-requests/' + this.req.id + '/cancel',
                        data: {
                            '_token': this.csrfToken,
                        },
                        success: (response, textStatus, jqXHR) => {
                            // promise 성공
                            resolve(response);
                        },
                    };

                    // ajax 실행
                    $.app.ajax.module.default(opts);
                });
            }).then((response) => {
                this.display = false;
                UIkit.modal.alert(response.msg).then(() => {
                    // 요청취소 완료 이벤트
                    this.$emit('canceled');

                });
            }).catch((msg) => {
                alert(msg);
            });



        },
    },
}
</script>

<style lang="scss" scoped>


// 컨펌화면
.confirm-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background-color: rgba(0, 0, 0, 0.7);
    z-index: 9999;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    .confirm-dialog {
        width: 30rem;
        max-width: 90%;

        background-color: #fff;

    }
}
</style>